import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import { take, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NologinGuard implements CanActivate {
  constructor(private AFauth:AngularFireAuth,private router:Router){}
  canActivate(
    route:ActivatedRouteSnapshot,
    ):Observable<boolean>{
   	 return this.AFauth.authState.pipe(take(1),map(auth=>{
   
		if (auth==null || auth==undefined) {
			this.router.navigate(['/']);
			return false;
		} else {
			return true;
		}
   	  }))
  
    }
  
}
